
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://ggdkyqjhmfmgkdwspsdz.supabase.co";
const supabaseKey = "sb_publishable_J2DmKoQX0Pfzd1sHWHGlbw_bRkopduI"
export const supabase = createClient(supabaseUrl, supabaseKey);
